module.exports = __webpack_public_path__ + "img/one.20b813a2.png";